import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutLoadTenderExpressProfileList extends Layout {
    layoutheaderLTXProfileList: LayoutHeader;
    sourceEdiLtxexpressProf: DataSource;
    table1: Table;
}
